import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { switchMap, withLatestFrom, map, catchError } from 'rxjs/operators';

import { Action, Store } from '@ngrx/store';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { DomainService } from 'modules/core/services/domain.service';
import { AppState, Selectors, Actions as RootActions } from 'store/root-reducer';
import {
  LoadList, DomainActionTypes, SetDomain, CreateDomain, CreateDomainSuccess,
  CreateDomainFailure, ChangeDomain
} from 'store/actions/domain.actions';
import { CurrentUser } from 'modules/shared/models/account.models';
import { Domain } from 'modules/shared/models/domain.models';
import { DomainResponse, DomainPayload, DomainsQuery } from 'store/models/domain.models';

import { SnackbarService } from 'app/services/snackbar.service';

@Injectable()
export class DomainEffects {

  constructor(
    private actions$: Actions,
    private domainService: DomainService,
    private store: Store<AppState>,
    private snackbar: SnackbarService,
  ) { }

  @Effect() LoadList: Observable<Action> = this.actions$.pipe(
    ofType<LoadList>(DomainActionTypes.LOAD_DOMAIN_LIST),
    map((action: LoadList) => action.payload),
    withLatestFrom(this.store.select(Selectors.auth.getUser)),
    switchMap(([payload, user]: [DomainsQuery, CurrentUser]) => {
      return this.domainService.getDomains(user.sub, payload).pipe(
        map((response: DomainResponse) => {
          return new RootActions.domain.LoadListSuccess(response.results);
        }),
        catchError((error) => {
          this.snackbar.error(error.message);
          return of(new RootActions.domain.LoadListFailure(error.message));
        })
      );
    })
  );

  @Effect() SetDomain: Observable<Action> = this.actions$.pipe(
    ofType<ChangeDomain>(DomainActionTypes.SET_DOMAIN),
    switchMap((input: SetDomain) => {
      return of(new RootActions.auth.GetUserRoles({ domainId: input.payload.id }));
    })
  );

  @Effect() ChangeDomain: Observable<Action> = this.actions$.pipe(
    ofType<ChangeDomain>(DomainActionTypes.CHANGE_DOMAIN),
    switchMap((input: SetDomain) => {
      return of(new RootActions.auth.GetUserRoles({ domainId: input.payload.id }));
    })
  );

  // Maybe use later.
  // @Effect() LoadListSuccess: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadListSuccess>(DomainActionTypes.LOAD_DOMAIN_LIST_SUCCESS),
  //   map((action: LoadListSuccess) => action.payload),
  //   withLatestFrom(this.store.select(Selectors.domain.getCurrentDomain)),
  //   map(([payload, domain]: [[Domain], Domain]) => {
  //     if (!domain) {
  //       return new RootActions.domain.SetDomain(payload);
  //     }
  //     return new RootActions.domain.SetDomain(domain);
  //   })
  // );

  @Effect() CreateDomain: Observable<Action> = this.actions$.pipe(
    ofType<CreateDomain>(DomainActionTypes.CREATE_DOMAIN),
    switchMap((action: CreateDomain) => {
      return this.domainService.createDomains(<DomainPayload>action.payload).pipe(
        switchMap((res: Domain) => {
          this.snackbar.success('Domain successfully created');
          return of(new CreateDomainSuccess(res));
        }),
        catchError((err: any) => {
          this.snackbar.error('Domain creation failed');
          return of(new CreateDomainFailure(err));
        })
      );
    }),
  );

}
